export default __webpack_public_path__ + "static/media/styles.6b72b760.styl";